"use client"

import * as React from "react"
import * as SeparatorPrimitive from "@radix-ui/react-separator"
import {clsx} from "clsx";

function AppSeparator({className, orientation = "horizontal", decorative = true, ...props}: React.ComponentProps<typeof SeparatorPrimitive.Root>) {
    return (
        <SeparatorPrimitive.Root
            data-slot="separator"
            decorative={decorative}
            orientation={orientation}
            className={clsx(
                "bg-gray shrink-0 data-[orientation=horizontal]:h-px data-[orientation=horizontal]:w-full data-[orientation=vertical]:h-full data-[orientation=vertical]:w-px",
                className
            )}
            {...props}
        />
    )
}

export { AppSeparator }
